<script setup>
import A11yDialog from 'a11y-dialog'

const props = defineProps({
  modalTitle: String,
  modalDescription: String,
  submissionSuccess: Boolean,
  modalId: {
    type: String,
    default: 'scalelit-modal',
  },
})

const dialogElement = ref(null)
let dialog = null

onMounted(() => {
  if (dialogElement.value)
    dialog = new A11yDialog(dialogElement.value)
  else console.error('dialogElement is not defined')
})

onBeforeUnmount(() => {
  if (dialog) {
    dialog.destroy()
    dialog = null
  }
})

watch(() => props.submissionSuccess, (value) => {
  if (value)
    dialog.hide()
})
</script>

<template>
  <div :id="modalId" ref="dialogElement" class="scalelit-modal dialog" aria-hidden="true">
    <div class="dialog-overlay" data-a11y-dialog-hide />
    <div class="dialog-content" role="document" aria-labelledby="dialog-title" aria-describedby="dialog-description">
      <button data-a11y-dialog-hide class="dialog-close" type="button" aria-label="Close dialog">
        {{ $t('Close') }}
      </button>

      <h2 v-if="props.modalTitle" id="dialog-title">
        {{ props.modalTitle }}
      </h2>
      <p v-if="props.modalDescription" id="dialog-description">
        {{ props.modalDescription }}
      </p>

      <slot />
    </div>
  </div>
</template>

<style scoped>
.scalelit-modal {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999999;
  position: fixed;
  justify-content: center;
  padding: 3rem;

  @media (width <=699px) {
    padding: 0.75rem;
  }
}

.dialog[aria-hidden="true"] {
  display: none;
}

.dialog-overlay {
  position: fixed;
  inset: 0;
  background: rgb(0 0 0 / 50%);
  animation: fade-in 200ms both;
}

.dialog-content {
  position: fixed;

  /* top: 20px; */
  left: 50%;
  transform: translate3d(-50%, 0, 0);
  padding: 0;
  max-width: 800px;
  width: 80%;
  max-height: 90%;
  background-color: white;
  border-radius: 6px;
  overflow: scroll;
  padding-top: 3rem;

  /**
   * 1. Add an animation delay equal to the overlay animation duration to
   *    wait for the overlay to appear before animation in the dialog.
   */
  animation: fade-in 400ms 200ms both, slide-up 400ms 200ms both;

  h2, p {
    padding-left: 3rem;
  }

  @media (width <=699px) {
    width: 95%;
  }
}

.dialog-close {
  position: absolute;
  top: 1rem;
  right: 1rem;
}

@keyframes fade-in {
  from {
    opacity: 0;
  }
}

@keyframes slide-up {
  from {
    /* transform: translateY(10%); */
    transform: translate3d(-50%, 10%, 0);
  }
}

@media (prefers-reduced-motion: reduce) {
  .dialog-overlay,
  .dialog-content {
    animation: none;
  }
}
</style>
